import { render } from "./Service.vue?vue&type=template&id=c83a3976"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\vue.js-3\\service-provider-project\\service-provider\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__